// Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved

import { css } from 'emotion';
import React from 'react';
// import axios from 'axios';
// import TodoInput from '../components/TodoInput';
import Header from '../components/Header';
import OrderList from '../components/OrderList';
import BarSearch from '../components/BarSearch';

const Order = () => {
  return (
    <>
      <Header />
      <div className={styles.root}>
        {/* <h1>Orders List</h1> */}
        <BarSearch textSearch={'Tracking NO.'} order={0}/>
        <OrderList />
      </div>
    </>
  );

  // async function start(username:string){
  //   const res = await axios.get(`http://122.155.201.108:8015/api/orders`)
  //       .then(res => {
  //         console.log(res);
  //         console.log(res.data);
  //         const {dealer,player ,result } = res.data
  //         dispatch({ type: 'updateGame', result: result });
  //         dispatch({ type: 'updateDealer', dealer: dealer });
  //         dispatch({ type: 'updatePlayer', player: player });
  //         setResult(result)
  //       })
  //     console.log(res)
  // }
}

const styles = {
  root: css`
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 25px 50px 0 rgba(0, 0, 0, 0.1);
    // font-family: system-ui;
    margin: 0 auto;
    padding: 35px 24px 24px 24px;
    width: 90%;
  `,
};
export default Order;